import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { ReactComponent as EventIcon } from '../../assets/icons/EventIcon.svg';
import { ReactComponent as ClientesIcon } from '../../assets/icons/ClientesIcon.svg';
import { ReactComponent as TimeIcon } from '../../assets/icons/TimeIcon.svg';
import { ReactComponent as LocationIcon } from '../../assets/icons/LocationIcon.svg';
import { ReactComponent as EditIcon } from '../../assets/icons/EditIcon.svg';
import { ReactComponent as DeleteIcon } from '../../assets/icons/DeleteIcon.svg';
import ConfirmationModal from '../ContactSideBar/ConfirmationModal'

const CalendarEventDetails = ({ onBack, onEdit, onDelete, event }) => {
  const [showConfirm, setShowConfirm] = useState(false);

const handleDeleteClick = () => {
  setShowConfirm(true);
};

const handleConfirmDelete = () => {
  if (onDelete && event) {
    onDelete(event.id); // Llamamos al callback pasado desde el padre
  }
  setShowConfirm(false);
};

const handleCancelDelete = () => {
  setShowConfirm(false);
};
  if (!event) {
    return null;
  }

  const { title, date, startHour, startMinutes, endHour, endMinutes, personas, location, description } = event;
const formatDate = (dateString) => {
  const date = new Date(dateString);
  const days = ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"];
  const months = [
    "enero", "febrero", "marzo", "abril", "mayo", "junio",
    "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"
  ];
  const dayName = days[date.getDay()];
  const day = date.getDate();
  const monthName = months[date.getMonth()];
  return `${dayName}, ${day} ${monthName}`;
};
  const formatTime = (hour, minutes) => {
    return `${String(hour).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
  };
  const formattedDate = formatDate(date);
  const formattedStartTime = formatTime(startHour, startMinutes);
  const formattedEndTime = formatTime(endHour, endMinutes);
  const personasInvolved = personas && personas.length > 0
    ? personas.join(', ')
    : 'N/A';

    
  return (
    <motion.div
      initial={{ x: '-100%' }}
      animate={{ x: 0 }}
      exit={{ x: '-100%' }}
      transition={{ duration: 0.15, ease: 'easeInOut' }}
      className="event-details"
    >
<div className="sidebar-header" style={{padding: '20px 0px 5px', justifyContent:'right',gap:'10px',margin:'0 auto', width:'90%'}}>
    <div className="sidebar-icon-container">
<EditIcon  onClick={() => onEdit(event)} className="menu-icon" style={{ height: '15px',margin: 'auto 0', cursor:'pointer' }} />
</div>
  <div className="sidebar-icon-container">
 <DeleteIcon
    onClick={handleDeleteClick}
className="menu-icon" style={{ height: '15px',margin: 'auto 0', cursor:'pointer' }}
  />
  </div>
 <button onClick={onBack} className="sidebar-close-button" style={{marginBottom:'2px'}}>&times;</button>

  </div>
  <div className="event-details-content" style={{paddingTop:'20px'}}>
    <div className="event-title-container">
      <h2 className="event-title">{title}</h2>
       <p className="info-text">{formattedDate} &bull; {formattedStartTime} - {formattedEndTime}</p>
    </div>
    {personas && personas.length > 0 && (
  <div className="event-info-section">
    <div className="info-row">
      <ClientesIcon className="info-icon" style={{ width: '20px', height: '20px' }} />
      <div className="info-text-container">
        <p className="info-text">{personas.join(', ')}</p>
      </div>
    </div>
  </div>
)}
    {location && (
      <div className="event-info-section">
        <div className="info-row">
          <LocationIcon className="info-icon" style={{ width: '20px', height: '20px' }} />
          <div className="info-text-container">
            <p className="info-text">{location}</p>
          </div>
        </div>
      </div>
    )}
    {description && (
      <div className="event-info-section">
        <div className="info-row">
          <EventIcon className="info-icon" style={{ width: '20px', height: '20px' }} />
          <div className="info-text-container">
            <p className="info-text">{description}</p>
          </div>
          </div>
      </div>
    )}
  </div>
  <ConfirmationModal
  isVisible={showConfirm}
  message="¿Estás seguro que deseas eliminar este evento?"
  onConfirm={handleConfirmDelete}
  onCancel={handleCancelDelete}
/>
</motion.div>
  );
};
export default CalendarEventDetails;
